// STYL — apparitions douces au scroll pour les éléments .styl-reveal
(() => {
  document.documentElement.classList.add('styl-js');

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const observer =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          (entries) => {
            for (const entry of entries) {
              if (!entry.isIntersecting) continue;
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          },
          { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
        )
      : null;

  const init = (root = document) => {
    const items = root.querySelectorAll('.styl-reveal:not(.is-visible)');
    for (const item of items) {
      if (!observer || reduceMotion.matches) {
        item.classList.add('is-visible');
      } else {
        observer.observe(item);
      }
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  // Éditeur de thème : réinitialise les sections rechargées
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

// Panier : champ « Réduction ». Sur certains Safari iOS, la propriété `inert`
// n'est pas reflétée en attribut : on resynchronise l'attribut avec aria-expanded
// après le clic, pour que le champ s'ouvre partout.
document.addEventListener('click', (event) => {
  const trigger = event.target instanceof Element ? event.target.closest('.cart-discount .disclosure-trigger') : null;
  if (!trigger) return;
  window.setTimeout(() => {
    const content = trigger.closest('.cart-discount')?.querySelector('.disclosure-content');
    if (!content) return;
    const expanded = trigger.getAttribute('aria-expanded') === 'true';
    content.toggleAttribute('inert', !expanded);
  }, 0);
});
